export const encodeBase64 = (string: string | undefined | null): string => {
  if (!string) return '';
  // Ensure we correctly encode UTF-8 characters. Using the default 'utf8'
  // encoding preserves multi-byte Unicode code points such as U+2019 (’).
  return Buffer.from(string, 'utf8').toString('base64');
};
